import { useMutation as useMutationBase } from 'shared-ui';

export const useMutation = useMutationBase;
